module.exports = __webpack_public_path__ + "img/SignIn_icon_02.70865c46.png";